export class PlatformDetection {
    constructor(private userAgent: string) {}

    public isMacOS(): boolean {
        return /Mac OS X/i.test(this.userAgent);
    }
}
